export default __webpack_public_path__ + "files/163427f821c91e787d5cf79b70824cf8.png";